module.exports = __webpack_public_path__ + "static/media/LogoBQ.431d6a8b.svg";